import React from 'react';
import RefinanceForm from '../components/RefinanceForm';

const form1 = () => <RefinanceForm />;

export default form1;
